import React from 'react';
import PropTypes from 'prop-types';
import { IoMdClose } from 'react-icons/io';
import { FiVolume2, FiVolumeX } from 'react-icons/fi';

const ExerciseHeader = ({ title, audio, setDisplayAlert, muteAudio }) => (
  <header className="exercises__header">
    <IoMdClose className="exercises__header_icon" onClick={setDisplayAlert} />
    <h2 className="exercises__header_title">{title}</h2>
    {audio.muted ? (
      <FiVolumeX className="exercises__header_icon" onClick={muteAudio} />
    ) : (
      <FiVolume2 className="exercises__header_icon" onClick={muteAudio} />
    )}
  </header>
);

ExerciseHeader.propTypes = {
  title: PropTypes.string.isRequired,
  audio: PropTypes.shape({ muted: PropTypes.bool }).isRequired,
  setDisplayAlert: PropTypes.func.isRequired,
  muteAudio: PropTypes.func.isRequired,
};

export default ExerciseHeader;
